<!-- 号車 -->
<template>
  <div class="row">
    <div class="th cell">号車</div>
    <div class="cell" v-if="selectedCarNumber == 0">指定しない</div>
    <div class="cell" v-else>{{ selectedCarNumber }}号車</div>
  </div>
</template>

<script>
export default {
  name: "StoreCarNumber",
  props: {
    selectedCarNumber: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.block {
  display: table;
  font-size: 13px;
}
.row {
  display: table-row;
}

.cell {
  font-weight: bold;
  display: table-cell;
  padding: 8px;
}
.th {
  font-weight: 100;
  padding-right: 14px;
  color: grey;
}
.arrow {
  width: 10px;
  height: auto;
  padding: 0 6px 1px 6px;
}
</style>
